import axios from '../../axios'

/*
 * 信息类型模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/system/sysInfoType/save',
    method: 'post',
    data
  })
};

// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/system/sysInfoType/delete',
    method: 'post',
    data
  })
};

// 列表
export const list = (data) => {
  return axios({
    url: '/system/sysInfoType/list',
    method: 'post',
    data
  })
};

// 查看
export const view = (data) => {
  return axios({
    url: '/system/sysInfoType/view',
    method: 'post',
    data
  })
};

// 编辑,新增
export const edit = (data) => {
  return axios({
    url: '/system/sysInfoType/edit',
    method: 'post',
    data
  })
};








// WEBPACK FOOTER //
// ./src/http/moudules/sys/infoType.js